import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const BoldIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 12H14C16.209 12 18 13.791 18 16C18 18.209 16.209 20 14 20H6V4H13C15.209 4 17 5.791 17 8C17 10.209 15.209 12 13 12"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

BoldIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(BoldIcon);
